export const TOGGLE_NEW_PROJECT = 'TOGGLE_NEW_PROJECT'

export const toggleNewProject = isVisible => ({
	type: TOGGLE_NEW_PROJECT,
	isVisible,
})
